import { Record as record } from 'immutable';

import UserPreferences from './UserPreferences';
import ValidationMixin from '../ValidationMixin';
import validators from '../../validation';

const defaults = {
    password: null,
    preferences: new UserPreferences(),
    telephoneNumber: null
};

class PasswordAndPreferencesForm extends record(defaults) {
    getSchema () {
        let schema = {};
        if (this.preferences.isSomeSmsPrefSetToTrue()) {
            schema = {
                telephoneNumber: validators.phone().required()
            };
        }
        return {
            ...schema,
            password: validators.passwordCreate().required(),
        };
    }
}

Object.assign(PasswordAndPreferencesForm.prototype, ValidationMixin);

export default PasswordAndPreferencesForm;



// WEBPACK FOOTER //
// ./src/records/customer/PasswordAndPreferencesForm.js